import React from 'react';
import { Redirect } from 'react-router-dom';

const PwaFireInsuranceBudgetRedirect: React.FC = () => (
  <Redirect to="/admin/fire-insurance-budget" />
);

export default PwaFireInsuranceBudgetRedirect;
